import React from "react"
import { IUIConfiguration } from "../model"
import { setTempUiConfigUndoRedo } from "../tools/undo-redo"
import { UiConfigColorPicker } from "./UiConfigColorPicker"

interface IUiConfigColorsProps {
  uiConfig: IUIConfiguration
}

export const UiConfigColors = React.memo(({ uiConfig }: IUiConfigColorsProps) => (
  <>
    <UiConfigColorPicker
      title="Primary"
      color={uiConfig.colors.primary}
      setColor={newColor => setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, primary: newColor } })}
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Primary 2"
      color={uiConfig.colors.primary2}
      setColor={newColor =>
        setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, primary2: newColor } })
      }
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Error"
      color={uiConfig.colors.error}
      setColor={newColor => setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, error: newColor } })}
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Form"
      color={uiConfig.colors.form}
      setColor={newColor => setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, form: newColor } })}
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Box shadow"
      color={uiConfig.colors.boxShadow}
      setColor={newColor =>
        setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, boxShadow: newColor } })
      }
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Background default"
      color={uiConfig.colors.backgroundDefault}
      setColor={newColor =>
        setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, backgroundDefault: newColor } })
      }
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Background paper"
      color={uiConfig.colors.backgroundPaper}
      setColor={newColor =>
        setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, backgroundPaper: newColor } })
      }
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Border"
      color={uiConfig.colors.border}
      setColor={newColor => setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, border: newColor } })}
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Border disabled"
      color={uiConfig.colors.borderDisabled}
      setColor={newColor =>
        setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, borderDisabled: newColor } })
      }
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Text primary"
      color={uiConfig.colors.textPrimary}
      setColor={newColor =>
        setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, textPrimary: newColor } })
      }
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Text secondary"
      color={uiConfig.colors.textSecondary}
      setColor={newColor =>
        setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, textSecondary: newColor } })
      }
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Text primary 2"
      color={uiConfig.colors.textPrimary2}
      setColor={newColor =>
        setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, textPrimary2: newColor } })
      }
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Text disabled"
      color={uiConfig.colors.textDisabled}
      setColor={newColor =>
        setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, textDisabled: newColor } })
      }
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Text special"
      color={uiConfig.colors.textSpecial}
      setColor={newColor =>
        setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, textSpecial: newColor } })
      }
      uiConfig={uiConfig}
    />
    <UiConfigColorPicker
      title="Text form"
      color={uiConfig.colors.textForm}
      setColor={newColor =>
        setTempUiConfigUndoRedo({ ...uiConfig, colors: { ...uiConfig.colors, textForm: newColor } })
      }
      uiConfig={uiConfig}
    />
  </>
))
